

























































































































































import ErrorMixin from "@/mixins/errorMixins";
import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import { User } from "@/shared/User";

@Component({
  components: {},
})
export default class ConfigFav extends mixins(MobileMixin, ErrorMixin) {
  public moi: User = new User();
  public editPass: boolean = false;
  public changes: boolean = false;
  public editLogin: boolean = false;
  public passError: boolean = false;
  public show: boolean = false;
  public show2: boolean = false;

  /**
   * passage en mode edition du mot de passe
   */
  public updatePass() {
    this.moi.newPassword = "";
    this.moi.rePasswordKey = "";
    this.editPass = true;
  }
  /**
   * methode de mise à jour de l'email et / ou du mot de passe de l'utilisateur
   */
  public save() {
    if (this.passError) {
      this.setErrorFromTxt(this.$t("DifferentPass").toString());
      return;
    } else {
      this.$store.dispatch("login/updateMe", this.moi).then(
        (response: any) => {
          console.log(response);
          this.editPass = false;
          this.moi.password = "";
          this.setSuccess(this.$t("SuccessMod").toString());
        },
        (error: any) => {
          console.log(error);
          this.setErrorFromTxt(this.$t("Error").toString());
        }
      );
    }
  }
  /**
   * methode permettant de comparer les deux mots de passe saisis
   */
  public comparePassword() {
    // console.log(this.moi);
    if (this.moi.newPassword === "") {
      this.passError = false;
    } else {
      if (this.moi.newPassword === this.moi.rePasswordKey) {
        this.passError = false;
        this.changes = true;
      } else {
        this.passError = true;
        this.changes = false;
      }
    }
    return this.passError;
  }

  public mounted() {
    // console.log(this.user);
    this.$store.dispatch("login/getUtilisateur", this.user).then(
      (data: any) => {
        this.moi = data;
      },
      (error: any) => {
        this.setErrorFromTxt(this.$t("Error").toString());
      }
    );
  }

  // computed
  get user(): User {
    return this.$store.getters["login/user"];
  }
}
